import * as React from 'react';
import { connect } from 'react-redux';

import { fetchOrganisation } from '@modules/organisation/actions';

import { parseSearchParams } from '@common/hooks/use-search-params';
import * as organisationSelector from '@modules/organisation/selectors/organisation';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Spinner from '../../../../common/components/spinner';
import Container from '../../../../common/components/container';
import RegistrationForm from '../../forms/registration';
import * as userSelector from '../../../core/selectors/logged-user';
import fetchProfileAction from '../../../core/actions/fetch-profile';

class RegistrationContainer extends React.Component {
  static defaultProps = {
    form: {},
  };

  componentDidMount() {
    if (!this.props.loggedUser || !this.props.loggedUser.user) this.props.fetchProfile();
    if (this.props.organisationId) this.props.fetchOrganisation(this.props.organisationId);
  }

  static props;

  render() {
    const {
      loggedUser, form, history, organisationId, isAdmin, organisation
    } = this.props;

    return (
      <Container name="Registration">
        <Container.Content>
          {loggedUser && organisation && organisation.id ? (
            <RegistrationForm
              history={history}
              isAdmin={isAdmin}
              initialValues={{
                first_name: loggedUser.first_name,
                last_name: loggedUser.last_name,
                phone_num: loggedUser.phone_num,
              }}
              loggedUser={loggedUser}
              formValues={form.values}
              organisationId={organisationId}
            />
          ) : <Spinner size="large" centered />}
        </Container.Content>
      </Container>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form.registration,
    loggedUser: userSelector.selected(state),
    isAdmin: userSelector.isAdmin(state),
    organisation: organisationSelector.selected(state),
    organisationId: (
      // if we are coming from password setting from the trial wizard
      parseSearchParams(props.location.search).org ||
      // otherwise if an organisation was already selected get the org id from
      // the selected company
      organisationSelector.selected(state)?.id
    )
  };
};

const mapDispatchToProps = {
  fetchProfile: fetchProfileAction,
  fetchOrganisation,
};

export default connect(mapStateToProps, mapDispatchToProps)(pageWrapper(EEventNames.VISITED_REGISTRATION_PAGE)(RegistrationContainer));
